<template>
  <de-layout-content>
    <div class="questionnaireTemplate">
      <div class="table">
        <el-radio-group v-model="type" @change="clickIsCollapse" style="margin-bottom: 20px;"
          v-if="userRole != 'ADMIN'">
          <el-radio-button :label="2">我创建的</el-radio-button>
          <el-radio-button :label="1">系统默认</el-radio-button>
        </el-radio-group>
        <!-- <div class="bl_title">问卷模版</div> -->
        <div class="seachAdd_line">
          <div class="seach">
            <el-input placeholder="输入搜索关键词" v-model="form.seachVal" clearable></el-input>
            <!-- <a-input placeholder="输入搜索关键词" v-model:value="form.seachVal" clearable /> -->
            <div class="seachIco" @click="seachBtn">
              <i class="el-icon-search"></i>
            </div>
          </div>

          <router-link to="quesTemplateEdit?enter=2" class="txt-white">
            <a-button type="primary" ghost class="xzwtBtn">
              <i class="el-icon-plus"></i>
              新建模板
            </a-button>
          </router-link>
          <!-- <a-button type="primary">新增问题</a-button> -->
        </div>

        <div v-if="templateList.length > 0">
          <div class="list">
            <div class="card" v-for="(item, index) in templateList" :key="index">
              <div class="setBtn" @click="setTemplateAuthor(item)" v-if="userRole == 'ADMIN'">
                <i class="el-icon-s-tools"></i>
              </div>
              <div class="sltBox" @click="previewTemplate(item, 2)">
                <div class="img">
                  <img :src="item.templateImg" alt="" v-if="item.templateImg">
                </div>
              </div>
              <div class="title" @click="previewTemplate(item, 2)">{{ item.templateName }}</div>
            </div>
          </div>
          <div class="listPage">
            <!-- <pagination v-show="total > 0"  layout="prev, pager, next" :total="total" :page.sync="form.pageNum" :limit.sync="form.pageSize"
            @pagination="getList" /> -->

            <pagination v-show="total > 0" :total="total" layout="total, prev, pager, next, jumper"
              :page.sync="form.pageNum" :limit.sync="form.pageSize" :showTotal="total" @pagination="getList" />

          </div>
        </div>

        <div v-else>
          <el-empty :image="noneImg" description="暂无问卷模板记录" />
        </div>

      </div>
    </div>

    <!-- 设置权限弹窗-start -->
    <el-dialog title="设置权限" :visible.sync="showSetting" width="800px" append-to-body>
      <div class="settingCont">
        <div class="flxL mr20">
          <el-checkbox v-model="menuNodeAll" @change="selectAll($event)">全选/全不选</el-checkbox>
          <div class="treeCont">
            <el-tree ref="tree" node-key="id" show-checkbox default-expand-all :data="treeData" :props="defaultProps"
              :default-checked-keys="checkKeys" @check-change="getCheck">
            </el-tree>
          </div>
        </div>
        <div class="flxR">
          <div class="preShow">
            <span>已选{{ checkNodes.length }}</span>
            <span class="clear" @click="clearNode">清空</span>
          </div>
          <div class="nodeList">
            <div class="node" v-for="(item, index) in checkNodes" :key="index">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSetting = false">取 消</el-button>
        <el-button type="primary" @click="setSubmit">确定</el-button>
      </div>
    </el-dialog>
    <!-- 设置权限弹窗-end -->
  </de-layout-content>
</template>

<script>
import * as API_Ques from "@/api/dataAccess/questionnaire";
import * as API_DataModel from '@/api/datamodel/index'
export default {
  data() {
    return {
      userRole: null,
      noneImg: require('@/assets/None.png'),
      type: 2,

      templateList: [],
      //数据分页参数
      total: 0,
      form: {
        seachVal: '',
        pageNum: 1,
        pageSize: 12,
      },
      checkKeys: [],
      checkNodes: [],
      showSetting: false,
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      treeData: [],
      queTemplateId: null,
      setForm: {
        organizationIdS: [],
      },
    };
  },

  mounted() {
  },
  created() {
    this.userRole = this.$store.state.user.roles.length && this.$store.state.user.roles[0].name || ''
    this.type = this.userRole == 'ADMIN' ? 1 : 2
    this.getList()
    this.getOrgList()
  },
  methods: {

    clickIsCollapse(e) {
      this.type = e
      this.getList()
    },

    getList() {
      const params = {
        pageNum: this.form.pageNum,
        pageSize: this.form.pageSize,
        templateName: this.form.seachVal,
        type: this.type,
      };
      API_Ques.pageManagementList(params).then(res => {
        if (res.code == 200) {
          this.templateList = res.data.list
          this.total = res.data.total;
        }
      })
    },

    // 搜索
    seachBtn() {
      this.getList()
    },

    // 点击预览问卷模版
    previewTemplate(e, enter) {
      this.$router.push({
        name: "quesTemplatePreview",
        query: {
          id: e.id,
          enter: enter,
          type: e.type,
        },
      });
    },

    // 点击设置模板-获取当前模板id的机构
    setTemplateAuthor(e) {
      this.queTemplateId = e.id
      const params = {
        queTemplateManagementId: e.id,
      };
      API_Ques.findSportsHallsListById(params).then(res => {
        this.showSetting = true
        this.checkNodes = res.data
        let checkKeys = res.data.map(item => item.id * 1)
        this.checkKeys = checkKeys
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(checkKeys, true)
        })
      })
    },

    // 权限操作弹窗-start
    getOrgList() {
      API_Ques.findSportsHallsList().then(res => {
        if (res.code == 200) {
          this.treeData = res.data.map(item => {
            return { ...item, id: item.id }
          })
        }
      })
    },
    selectAll(value) {
      this.$refs.tree.setCheckedNodes(value ? this.treeData : []);
    },
    clearNode() {
      this.checkKeys = []
      this.checkNodes = []
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([], true)
      })
    },
    getCheck() {
      this.checkNodes = this.$refs.tree.getCheckedNodes();
      this.checkKeys = this.checkNodes.map(item => item.id)
    },

    setSubmit() {
      if (!this.checkKeys.length) {
        this.$message({ message: '请设置模版权限', type: 'error' });
        return
      }
      const params = this.setForm
      params.organizationIdS = this.checkKeys
      params.queTemplateId = this.queTemplateId
      API_Ques.addTemplateJoin(params).then(res => {
        if (res.code == 200) {
          this.$message.success("操作成功");
          this.showSetting = false
          this.getList()
        }
      })
    },
    // 权限操作弹窗-end
  },

};
</script>

<style lang='less' scoped>
.questionnaireTemplate {
  padding-top: 18px;
  padding-bottom: 100px;
  display: inline-block;
  width: 100%;
  max-width: 1625px;

  .listPage {
    text-align: right;
  }

  .seachAdd_line {
    // margin: 28px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .seach {
      background-color: #21284B;
      border-radius: 4px;
      width: 400px;
      display: flex;
      // border:1px solid rgba(255,255,255,.5);

      ::v-deep.el-input {
        background-color: #21284B !important;
        border: 0 !important;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        flex: 1;

        .el-input__inner {
          height: 40px;
        }
      }

      .seachIco {
        font-size: 20px;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        color: #fff;
        transition: all linear .3s;
        cursor: pointer;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;

        &:hover {
          background-color: #1890FF;
          transition: all linear .3s;
        }
      }
    }

    .xzwtBtn {
      height: 40px !important;

      .acticon {
        color: #1890FF;
      }
    }

    .txt-white {
      margin-right: 30px;
    }
  }

  .list {
    width: 100%;
    display: inline-block;
    margin-right: -13px;
    margin-left: -13px;

    .card {
      width: 380px;
      float: left;
      margin: 26px 13px 0 13px;
      padding: 16px;
      border-radius: 4px;
      background: #21284B;
      position: relative;

      .setBtn {
        i {
          border: 1px solid #fff;
          padding: 4px;
          border-radius: 4px;
          position: absolute;
          z-index: 1;
          right: 21px;
          top: 21px;
          cursor: pointer;
          color: #fff;
          transition: linear .3s all;

          &:hover {
            background-color: #197BE4;
            border-color: #197BE4;
          }
        }
      }

      &:hover {
        opacity: .8;
        transition: linear .3s all;

        .sltBox {
          border: 1px solid rgba(255, 255, 255, .3);
          transition: linear .3s all;
        }
      }

      .sltBox {
        width: 348px;
        height: 348px;
        display: inline-block;
        overflow: hidden;
        position: relative;
        border: 1px solid transparent;
        background-color: #141937;
        box-sizing: border-box;
        padding: 10px;
        border-radius: 4px;
        cursor: pointer;
        transition: linear .3s all;
      }

      .img {
        img {
          width: 100%;
          min-height: 100%;
          object-fit: cover;
        }


      }

      .title {
        width: 100%;
        display: inline-block;
        font-size: 16px;
        color: #fff;
        font-weight: bold;
        margin-top: 5px;
        cursor: pointer;

        &:hover {
          color: rgba(255, 255, 255, .7);
        }
      }
    }

    // .card:nth-child(4n) {
    //   margin-right: 0;
    // }

    // .card:nth-child(4n+1) {
    //   margin-left: 0;
    // }
  }
}
</style>
